import { useState, useEffect } from "react";
import {
  Typography,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  TextField,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import Button from "../../../../../componentsv2/Button";

import { useSnackbar } from "notistack";
import { api } from "../../../../../services/Api";
import converteDataUS from "../../../../../utils/converteDataUS";
import useUser from "../../../../../hooks/useUser";
import DataPickerAtualizado from "../../../../../components/DataPickerAtualizado";

const ModalConfirmaLote = ({
  open,
  handleClose,
  convenio,
  valorSoftlab,
  valorDoLote,
  setValorDoLote,
  getTotalSoftlab,
  lote,
  mesCompetencia,
  anoCompetencia,
}) => {
  const { enqueueSnackbar } = useSnackbar();

  // const [mesCompetencia, setMesCompetencia] = useState("");
  // const [anoCompetencia, setAnoCompetencia] = useState("");
  const [protocolo, setProtocolo] = useState("");
  const [previsao, setPrevisao] = useState(null);

  const usuario = useUser();

  const salvarLote = async () => {
    const previsaoFormatada = previsao ? converteDataUS(previsao) : null;

    try {
      await adicionarProtocolo(previsaoFormatada);

      await api.post("/v2/faturamento/adicionaLote", {
        data_envio_lote: new Date(),
        codigo: lote,
        plano: convenio,
        protocolo: protocolo,
        data_protocolo: new Date(),
        data_previsao: previsaoFormatada,
        valor: valorDoLote,
        valor_alterado: valorSoftlab,
        quantidade: 1,
        em_construcao: false,
        usuario_responsavel: usuario,
      });
      enqueueSnackbar("Lote e protocolo adicionados.", {
        variant: "success",
      });
      getTotalSoftlab();
      handleClose(false);
      limparDados();
    } catch (error) {
      console.log(error);

      enqueueSnackbar("Erro ao salvar lote.", {
        variant: "error",
      });
    }
  };

  const adicionarProtocolo = async (previsaoFormatada) => {
    try {
      await api.post(`/v2/faturamento/salvaProtocolo`, {
        protocolo: protocolo,
        previsao: previsaoFormatada,
        codigo: lote,
        plano: convenio,
        mes_competencia: mesCompetencia,
        ano_competencia: anoCompetencia,
      });
    } catch (error) {
      console.log(error);
    }
  };

  const handleValorDoLote = (e) => {
    const valorLimpo = e.target.value.replace(/\D/g, "");

    if (!valorLimpo) {
      setValorDoLote(0);
      return;
    }

    const valorNumerico = parseFloat(valorLimpo) / 100;

    if (valorNumerico > valorSoftlab) {
      setValorDoLote(valorSoftlab);
      enqueueSnackbar(
        `O valor não pode ser maior que ${valorSoftlab?.toLocaleString(
          "pt-BR",
          {
            style: "currency",
            currency: "BRL",
          }
        )}`,
        {
          variant: "warning",
        }
      );
    } else {
      setValorDoLote(valorNumerico);
    }
  };

  const limparDados = () => {
    setProtocolo("");
    // setMesCompetencia("");
    // setAnoCompetencia("");
  };

  useEffect(() => {
    if (valorSoftlab) {
      setValorDoLote(valorSoftlab);
    }
  }, [valorSoftlab]);

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={open}
      onClose={handleClose}
      scroll="paper"
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
    >
      <DialogTitle
        id="scroll-dialog-title"
        sx={{ justifyContent: "space-between" }}
      >
        <Grid container justifyContent="space-between">
          <Grid item>
            <Typography variant="h6">Salvar Lote</Typography>
          </Grid>
          <Grid item>
            <IconButton onClick={() => handleClose(false)}>
              <Close />
            </IconButton>
          </Grid>
        </Grid>
      </DialogTitle>

      <DialogContent dividers sx={{ padding: "24px" }}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: 600, mb: 2, color: "primary.main" }}
            >
              Informações Básicas
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  id="lote"
                  label="Lote"
                  value={lote}
                  disabled
                  fullWidth
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  id="protocolo"
                  label="Protocolo"
                  value={protocolo}
                  onChange={(e) => setProtocolo(e.target.value)}
                  fullWidth
                  variant="outlined"
                  required
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  id="convenio"
                  label="Convênio"
                  value={convenio}
                  disabled
                  fullWidth
                  variant="outlined"
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: 600, mb: 2, color: "primary.main" }}
            >
              Competência
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={6} sm={3}>
                <TextField
                  id="mesCompetencia"
                  label="Mês"
                  placeholder="MM"
                  value={mesCompetencia}
                  disabled
                  // onChange={(e) => setMesCompetencia(e.target.value)}
                  inputProps={{ maxLength: 2, inputMode: "numeric" }}
                  fullWidth
                  variant="outlined"
                  required
                />
              </Grid>
              <Grid item xs={6} sm={3}>
                <TextField
                  id="anoCompetencia"
                  label="Ano"
                  placeholder="AAAA"
                  value={anoCompetencia}
                  disabled
                  // onChange={(e) => setAnoCompetencia(e.target.value)}
                  inputProps={{ maxLength: 4, inputMode: "numeric" }}
                  fullWidth
                  variant="outlined"
                  required
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <DataPickerAtualizado
                  data={previsao}
                  setData={setPrevisao}
                  labelName="Data de Previsão"
                  required
                  fullWidth
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: 600, mb: 2, color: "primary.main" }}
            >
              Valores
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  id="valorSoftlab"
                  label="Valor Softlab"
                  value={valorSoftlab?.toLocaleString("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  })}
                  disabled
                  fullWidth
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  id="valorDoLote"
                  label="Valor do Lote"
                  placeholder="R$ 0,00"
                  value={valorDoLote?.toLocaleString("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                    minimumFractionDigits: 2,
                  })}
                  onChange={(e) => handleValorDoLote(e)}
                  inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                  fullWidth
                  variant="outlined"
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions
        sx={{
          padding: "20px 24px",
          backgroundColor: "#f8f9fa",
          borderTop: "1px solid #e0e0e0",
        }}
      >
        <Grid container justifyContent="flex-end" spacing={2}>
          <Grid item>
            <Button
              color="gray"
              variant="outlined"
              onClick={() => {
                handleClose(false);
                limparDados();
              }}
              sx={{ minWidth: "120px" }}
            >
              Cancelar
            </Button>
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              color="green"
              onClick={() => salvarLote()}
              sx={{ minWidth: "120px" }}
            >
              Salvar Lote
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
};

export default ModalConfirmaLote;
